import { useMutation } from '@tanstack/react-query'
import { deleteAddon } from '../services/mapServices'

export function useAddonDelete() {

  const {
    mutate: addonDelete,
    isLoading: isLoadingAddonDelete,
    error,
    isSuccess,
  } = useMutation({
    mutationFn: deleteAddon,
  })

  return {
    addonDelete,
    isLoadingAddonDelete,
    error,
    isSuccessAddonDelete: isSuccess,
  }
}